import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

// Module-level so reopening the paywall doesn't refetch within the same session.
let pricesPromise = null;

const fetchPrices = () => {
  if (!pricesPromise) {
    pricesPromise = Promise.resolve()
      .then(() => axios.get(`${API}/subscription/prices`))
      .then((res) => res?.data?.prices || null)
      .catch(() => {
        pricesPromise = null; // allow a retry on the next mount
        return null;
      });
  }
  return pricesPromise;
};

/**
 * Live Stripe display price for the web paywall.
 *
 * `currency` is 'eur' | 'usd'. The amount always originates from the Stripe
 * dashboard — there is no hardcoded fallback, because showing a stale or
 * invented price next to a Buy button is worse than showing none. While the
 * request is in flight (or if it fails) `lifetime` is null and callers should
 * render a placeholder rather than a number.
 */
export function useStripePrices(currency = 'usd') {
  const [prices, setPrices] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchPrices().then((data) => {
      if (!cancelled && data) setPrices(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const chosen = prices ? (prices[currency] || prices.usd) : null;
  const lifetime = Number(chosen?.lifetime) || null;

  return { lifetime, loading: prices === null };
}

export default useStripePrices;
